import { Controller } from "@hotwired/stimulus"
import { replayAnimation } from "../lib/motion"

// Ad upgrade page: picking a tier slides the submit label to that plan and points the confirm dialog at it.
export default class extends Controller {
  static targets = ["label"]

  // A browser may restore a different checked radio on reload: start from whatever is checked.
  connect() {
    const checked = this.element.querySelector('input[name="plan"]:checked')
    if (checked) this.apply(checked)
  }

  pick(event) {
    this.apply(event.currentTarget)
    replayAnimation(this.labelTarget, "upgrade-cta-label--in")
  }

  apply(input) {
    this.labelTarget.textContent = input.dataset.label
    this.element.dataset.turboConfirm = input.dataset.confirm
  }
}
